//import { MultipleDayBooleanInputs } from "./MultipleDayBooleanInputs";
//import { AppUsers } from "./AppUsers";
//import { DataSafe } from "@/models/DataSafe"

export class PeriodData {
     static attributePrefix = "Discharge";
     static attributePrefixDe = "Ausfluss";


}